/* eslint-disable jsx-a11y/no-static-element-interactions */
import { T } from '../../../utils/I18n/I18n'
import clsx from 'clsx';
import React, { useMemo } from 'react';
import defaultConfiguration from '../../../config/default.json';
import DeliveryTruck from '../../../assets/icons/delivery-truck 2.png';
import Pencil from '../../../assets/icons/pen 1.png';
import Vector from '../../../assets/icons/Vector.png';
import CountryById from '../../../components/PersonalArea/PersonalAreaAddress/CountrySelect/CountryById';
import readClientConfiguration from '../../../utils/readClientConfiguration';

const countryCode = readClientConfiguration(defaultConfiguration, 'countryCode');

const CheckoutAddressItem = ({
  addresses,
  addressId,
  setAddressId,
  savedAddress,
  setEditAddressId,
  savedToAddressBook,
  setIsDirty,
}) => {
  const { firstname, lastname, street, city, postcode, telephone, id, country_code } = savedAddress;

  const setActiveHandler = id => {
    if (id !== addressId) {
      setAddressId(id);
      setIsDirty(true);
    }
  };

  const filtered = useMemo(
    () =>
      addresses.filter(address => {
        return countryCode.includes(address.country_id);
      }),
    [addresses],
  );

  return (
    <>
      {filtered.map(({ firstname, lastname, street, postcode, country_id, city, telephone, id, country_code }) => (
        <div
          key={id}
          className={clsx('checkout-address-item', addressId === id && 'checkout-address-item__is-active')}
          onClick={() => setActiveHandler(id)}
        >
          <p>
            {firstname} {lastname}
          </p>
          <p>{street[0]}</p>
          <p>
            {city} {postcode}
          </p>
          <p>
            <CountryById id={country_code || country_id} />
          </p>
          <p>{telephone}</p>

          {addressId === id && <img className="checkout-address-item__is-active-vector" src={Vector} alt="" />}

          {addressId !== id && (
            <div className="checkout-address-item__send-here">
              <img src={DeliveryTruck} alt="" />
              <span className="checkout-address-item__send-here">
                <T id="address.sendHere" />
              </span>
            </div>
          )}

          {savedToAddressBook.identifier === id && savedToAddressBook.added && savedAddress.firstname && (
            <div className="checkout-address-item__send-here" onClick={() => setEditAddressId(id)}>
              <img src={Pencil} alt="" />
              <span className="checkout-address-item__send-here">
                <T id="address.edit" />
              </span>
            </div>
          )}
        </div>
      ))}

      {savedAddress && savedAddress.firstname && !savedToAddressBook.identifier && (
        <div
          className={clsx('checkout-address-item', addressId === 'savedAddress' && 'checkout-address-item__is-active')}
          onClick={() => setActiveHandler(id)}
        >
          <p>
            {firstname} {lastname}
          </p>

          <p>{street}</p>

          <p>
            {city} {postcode}
          </p>

          <p>
            <CountryById id={country_code} />
          </p>

          <p>{telephone}</p>

          {addressId === 'savedAddress' && (
            <img className="checkout-address-item__is-active-vector" src={Vector} alt="" />
          )}

          <div className="checkout-address-item__send-here" onClick={() => setEditAddressId(id)}>
            <img src={Pencil} alt="" />
            <span className="checkout-address-item__send-here">
              <T id="address.edit" />
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default CheckoutAddressItem;
